package pl.michal_cyran.brand_hub.components.sections

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ListStyleType
import com.varabyte.kobweb.compose.css.functions.colorMix
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.flexDirection
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.gridTemplateColumns
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.listStyle
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.FaEnvelope
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.navigation.UncoloredLinkVariant
import com.varabyte.kobweb.silk.components.navigation.UndecoratedLinkVariant
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexDirection
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.fr
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul
import pl.michal_cyran.brand_hub.BaseCardStyle
import pl.michal_cyran.brand_hub.BtnPrimaryStyle
import pl.michal_cyran.brand_hub.CardStyle
import pl.michal_cyran.brand_hub.FooterBottomStyle
import pl.michal_cyran.brand_hub.FooterContactBoxStyle
import pl.michal_cyran.brand_hub.FooterContactEmailStyle
import pl.michal_cyran.brand_hub.FooterContainerStyle
import pl.michal_cyran.brand_hub.FooterGridStyle
import pl.michal_cyran.brand_hub.FooterStyle
import pl.michal_cyran.brand_hub.subpages.main.hero.SocialLinks
import pl.michal_cyran.brand_hub.components.widgets.FullName
import pl.michal_cyran.brand_hub.components.widgets.PrimaryButton
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun Footer(modifier: Modifier = Modifier) {
    Column(
        FooterStyle
            .toModifier()
            .id("kontakt")
            .then(FooterContainerStyle.toModifier())
        ,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        SimpleGrid(
            numColumns(base = 1, md = 3),
            FooterGridStyle.toModifier()
        ) {
            Column {
                FullName()
                P(
                    attrs = Modifier
                        .margin(top = 16.px)
                        .maxWidth(384.px)
                        .lineHeight(1.6)
                        .fontSize(15.px) // Poprawa czytelności fontu
                        .color(ColorMode.current.toSitePalette().cardTextBody)
                        .toAttrs()
                ) {
                    Text("Skuteczne korepetycje z matematyki i informatyki w Krakowie oraz online. Pomagam zrozumieć trudne zagadnienia, zdać maturę i zaliczyć egzaminy zawodowe.")
                }
                Box(Modifier.margin(top = 24.px)) {
                    SocialLinks()
                }
            }

            Column {
                P(
                    attrs = Modifier
                        .fontWeight(FontWeight.SemiBold)
                        .fontSize(18.px)
                        .color(ColorMode.current.toSitePalette().textHeading)
                        .margin(top = 0.px, bottom = 0.px)
                        .toAttrs()
                ) { Text("Oferta i usługi") }

                Ul(
                    attrs = Modifier
                        .margin(top = 16.px)
                        .display(DisplayStyle.Flex)
                        .flexDirection(FlexDirection.Column)
                        .gap(12.px)
                        .listStyle(ListStyleType.None)
                        .padding(0.px)
                        .toAttrs()
                ) {
                    listOf(
                        "Korepetycje" to "https://michal-cyran.pl/tutoring",
                        "Aplikacja" to "https://michal-cyran.pl/day-math",
                        "Zadania maturalne" to "https://egzaminy.michal-cyran.pl/",
                        "Freelancing" to "https://michal-cyran.pl/freelancing"
                    ).forEach { (label, href) ->
                        Li {
                            Link(
                                path = href, modifier = FooterStyle.toModifier()
                                    .fontSize(15.px)
                                    .fontWeight(FontWeight.Medium),
                                variant = UndecoratedLinkVariant.then(UncoloredLinkVariant)
                            ) {
                                Text(label)
                            }
                        }
                    }
                }
            }

            Column(
                verticalArrangement = Arrangement.spacedBy(1.cssRem)
            ) {
                P(
                    attrs = Modifier
                        .fontWeight(FontWeight.SemiBold)
                        .fontSize(18.px)
                        .color(ColorMode.current.toSitePalette().textHeading)
                        .margin(top = 0.px, bottom = 0.px)
                        .toAttrs()
                ) { Text("Kontakt") }

                Column(
                    CardStyle.toModifier().padding(20.px), // Lekko powiększony padding dla estetyki
                    verticalArrangement = Arrangement.spacedBy(0.75.cssRem)
                ) {
                    P(
                        attrs = Modifier.fontSize(15.px)
                            .fontWeight(FontWeight.Bold)
                            .color(ColorMode.current.toSitePalette().textHeading)
                            .margin(top = 0.px, bottom = 0.px)
                            .toAttrs()
                    ) { Text("Napisz do mnie!") }

                    P(
                        attrs = Modifier
                            .fontSize(13.px)
                            .lineHeight(1.4)
                            .color(ColorMode.current.toSitePalette().cardTextBody)
                            .margin(top = 0.px, bottom = 0.px)
                            .toAttrs()
                    ) { Text("Chętnie odpowiem na Twoje pytania i ustalimy dogodny termin zajęć.") }


                    PrimaryButton(
                        path = "mailto:kontakt@michalcyran77777@gmail.com",
                        text = "Wyślij e-mail",
                        icon = { FaEnvelope() }
                    )
                }
            }
        }

        Div(FooterBottomStyle.toModifier().toAttrs()) {
            P(
                attrs = Modifier.fontSize(14.px)
                    .color(ColorMode.current.toSitePalette().footerTextMuted)
                    .toAttrs()
            ) { Text("© 2026 Michał Cyran. Wszelkie prawa zastrzeżone.") }
        }
    }
}